import { useState, useEffect, useContext } from 'react'
import dynamic from 'next/dynamic'

import { StateContext } from '~~/src/context/context'

import NavComponent from '~~/src/components/Nav_comp/NavComponent'
const HamburgerMenu = dynamic(() => import('~~/src/components/Nav_comp/HamburgerMenu'), { ssr: false })
const SignMsg = dynamic(() => import('~~/src/components/Network_comp/SignMsg'), { ssr: false })
import LogoBanner from '~~/src/components/Nav_comp/LogoBanner'
import useIntersectionObserver from '~~/src/hooks/deepcity-ux/useIntersectionObserver'

function NavBar() {
  const { displayMenu } = useContext(StateContext)
  const [nav, setNav] = useState(false)
  const [shouldLoad, targetRef] = useIntersectionObserver();

  useEffect(function mount() {
    function onScroll() {
      if (window.scrollY >= 200) {
        setNav(true)
      } else {
        setNav(false)
      }
    }

    window.addEventListener('scroll', onScroll)

    return function unMount() {
      window.removeEventListener('scroll', onScroll)
    }
  })

  const style = {
    wrapper: `z-30 relative overflow-x-hidden flex`,
    navBar: `flex `,
    navContent: ` ${nav ? 'backdrop-blur-sm bg-white/30 ' : 'opacity-100 bg-white'
      } dark:bg-[#2a2e35] w-screen fixed  grid `,
    menuContent: `relative`,

  }

  return (
    <nav className={style.wrapper}>
      <div className={`flex flex-col`}>
        <header className={style.navContent + `h-[4.5rem] md:px-12`}>
          <LogoBanner />
          <NavComponent />
        </header>
      </div>
      <div className={style.menuContent}>
        {displayMenu && <HamburgerMenu />}
      </div>
      {shouldLoad ?
        <SignMsg /> :
        <div ref={targetRef}>
        </div>
      }
    </nav >

  )
}

export default NavBar